<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { cloneDeep, groupBy } from "lodash";
import MainTargetTemplate from './main-target-template.vue';
import { required } from "vuelidate/lib/validators";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Switches from "vue-switches";
import Swal from "sweetalert2";
import ApiType from "@/components/modals/api-type.vue";
import PlanningRatingScale from "@/components/modals/planning-rating-scale.vue"
export default {
    page: {
        title: "Target Template",
    },
    components: {
        Layout,
        PageHeader,
        MainTargetTemplate,
        MaskedInput,
        Switches,
        ApiType,
        PlanningRatingScale
    },
    data() {
        return {
            title: "Target Template",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Target Template",
                    active: true,
                },
            ],
            indicators: [],
            campusTemplate: null,
            filterBy: 'all',
            filter: '',
            modalTitle: "",
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: false,
                allowDecimal: true,
            }),
            target: {
                id: 0,
                planningTemplateId: 0,
                indicatorItemId: 0,
                description: "",
                overAllTarget: "",
                isPercentage: false,
                allowAdd: false,
            },
            api: {
                id: 0,
                planningTemplateDeliveryUnitId: null,
                name: null,
                description: null,
                apiTypeId: null,
                priority: null,
                apiType: null,
            },
            parentIndicator: null,
            apiData: [],
            viewingApi: false,
            addApi: false,
            selectedDU: null,
            apiLoading: false,
            selectedPlanningMainTarget: null,
            itemClassifications: [],
        }
    },
    validations: {
        target: {
            indicatorItemId: { required},
            description: { required },
            overAllTarget: { required },
        },
        api: {
            name: { required },
            description: { required },
            apiTypeId: { required },
        }
    },
    async mounted() {
        this.pageLoader(true);
        await this.getIndicators();
        // await this.getCampusTemplate(this.$store.state.data.selectedCampus.id);
        await this.getClassifications();
        this.pageLoader(false);
    },
    computed: {
        filtered() {
            let data = this.indicators;
            // var total = this.currentPage * this.perPage;
            if (this.filterBy === "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                            .toUpperCase()
                            .includes(this.filter.toUpperCase());
                    });
                }
            } else {
                data = data.filter((item) => {
                    return item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
            // data = data.slice(total - this.perPage, total);
            return data;
        },
    },
    methods: {
        async getClassifications(){
            this.$store
            .dispatch(
                "indicatoritemclassification/GetIndicatorItemClassification"
            )
            .then((res) => {
                this.itemClassifications = res.data;
            })
            .catch(() => {
                this.showToast("Something went wrong!", "error");
            });
        },
        async getIndicators() {
            await this.$store
                .dispatch("indicator/GetIndicator")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.map((item) => {
                        item.indicatorItems.forEach((x) => {
                            x.visible = false;
                            x.mainTargets = [];
                            x.mainTargetLoading = false;
                            x.singleSelection = true;
                            x.selectedTargets = [];
                        });
                        item.openFI = false;
                        item.prexcGrp = item.prexc.prexcName.replace(/\s/g, '').toLowerCase();
                        item.prexcClassGrp = item.prexc.prexcClassification.classification.replace(/\s/g, '').toLowerCase();
                        item.searchFilter = '';
                    });
                    let classGrp = groupBy(res.data, 'prexcClassGrp');
                    let grpData = [];
                    let itemClasses = [];
                    for (const [key, value] of Object.entries(classGrp)) {
                        let grp = groupBy(value, 'prexcGrp');
                        let resData = [];
                        let upFilterKey = "";
                        for (const [gKey, gValue] of Object.entries(grp)) {
                            let filterKey = "";
                            gValue[0].indicatorItems.forEach((x) => {
                                filterKey += x.indicatorItemName + " ";
                                itemClasses.push(x.indicatorItemClassification.classification);
                                upFilterKey += x.indicatorItemName + " ";
                            });
                            gValue.map(item => {
                                let iClass = [];
                                item.indicatorItems.map(x => {
                                    iClass.push(x.indicatorItemClassification.classification)
                                })
                                item.itemClasses = iClass.join(" ");
                            })
                            resData.push({
                                id: gValue[0].prexcId,
                                prexc: gValue[0].prexc,
                                items: gValue,
                                rotateChevy: false,
                                filterKey: filterKey + ` ${gValue[0].prexc.prexcName}`,
                                searchClass: itemClasses.join(" ")
                            });
                            upFilterKey += gValue[0].prexc.prexcName;
                        }
                        grpData.push({
                            id: key,
                            prexcClass: value[0].prexc.prexcClassification,
                            items: resData,
                            filterKey: upFilterKey + ` ${value[0].prexc.prexcClassification.classification}`,
                            searchClass: itemClasses.join(" ")
                        });
                    }
                    this.indicators = grpData;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong! - getting indicators",
                        "error"
                    );
                });
        },
        async getCampusTemplate(id){
            await this.getTemplate(id);
            if(!this.campusTemplate){
                this.createTemplate();
            }
        },
        async getTemplate(id){
            await this.$store
                .dispatch("planningtemplate/GetPlanningTemplate", id)
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.campusTemplate = res.data.length > 0 ? res.data[0] : null;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong! - getting pre-planning",
                        "error"
                    );
                });
        },
        createTemplate(){
            this.$store
                .dispatch("planningtemplate/CreatePlanningTemplate", {
                    templateDescription: `${this.$store.state.data.selectedCampus.campusName} Template`,
                    campusId: this.$store.state.data.selectedCampus.id,
                })
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    this.campusTemplate = res.data;
                })
                .catch(() => {
                    this.showToast(
                        "Something went wrong! - creating pre-planning",
                        "error"
                    );
                });
        },
        filteredPrexc(items){
            let data = items;
            if (this.filterBy == "all") {
                if (this.filter.trim() != "" && this.filter) {
                    data = data.filter((item) => {
                        return item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                    });
                }
                return data;
            } else {
                return data.filter((item) => {
                    return item.searchClass.includes(this.filterBy) && item.filterKey
                        .toUpperCase()
                        .includes(this.filter.toUpperCase());
                });
            }
        },
        filteredGroupIndicators(data){
            let filteredData = [];
            if(this.filterBy == "all")
                filteredData = data;
            else {
                filteredData = data.filter((item) => item.itemClasses.toLowerCase().includes(this.filterBy.toLowerCase()));
            }
            return filteredData
        },
        filteredIndicatorItems(data, filter) {
            let filteredData = [];
            if(this.filterBy == "all")
                filteredData = data;
            else {
                filteredData = data.filter((item) => item.indicatorItemClassification.classification.toLowerCase() === this.filterBy.toLowerCase());
            }
            if (filter.trim() != "" && filter) {
                filteredData = filteredData.filter((item) => {
                    return item.indicatorItemName
                        .toUpperCase()
                        .includes(filter.toUpperCase());
                });
            }
            return filteredData;
        },
        async viewMainTargets(row){
            row.visible = !row.visible;
            if(row.visible){
                row.mainTargetLoading = true;
                await this.$store
                    .dispatch(
                        "planningtemplatemaintarget/GetAllPTMTByIndicatorItem", row.id
                        // templateId: this.campusTemplate.id,
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.forEach(item => {
                            item.visible = false;
                            item.addDU = false;
                            item.mandatoryVisible = false;
                            item.mandatoryApis = cloneDeep(this.mandatoryApis);
                            item.targetTemplateDeliveryUnits = [];
                            item.loadDU = false;
                            item.selectedTarget = false;
                            item.zIndex = 0;
                        })
                        row.mainTargets = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
                row.mainTargetLoading = false;
            }
        },
        onResetTarget(row) {
            this.target = {
                id: 0,
                planningTemplateId: 0,
                indicatorItemId: cloneDeep(row.id),
                description: cloneDeep(row.indicatorItemName),
                overAllTarget: "",
                isPercentage: false,
                allowAdd: false,
            };
        },
        createNewTarget(row) {
            this.parentIndicator = row;
            this.onResetTarget(row);
            this.modalTitle = "Create New Target";
            this.$bvModal.show("create-target-modal");
        },
        async onCreateTarget() {
            this.submitted = true;
            this.$v.target.$touch();
            if (this.$v.target.$invalid) {
                return;
            }
            let data = cloneDeep(this.target);
            data.overAllTarget = this.getExactAmt(this.target.overAllTarget);
            // data.planningTemplateId = this.campusTemplate.id;
            if (this.target.id > 0) {
                await this.$store
                    .dispatch(`planningtemplatemaintarget/UpdatePTMT`, data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        let index = this.parentIndicator.mainTargets.findIndex((x) => x.id == this.target.id);
                        this.parentIndicator.mainTargets.splice(index, 1, data);
                        this.$bvModal.hide("create-target-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            } else {
                await this.$store
                    .dispatch(`planningtemplatemaintarget/CreatePTMT`, data)
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.targetTemplateDeliveryUnits = [];
                        res.data.visible = false;
                        res.data.addDU = false;
                        res.data.mandatoryVisible = false;
                        res.data.mandatoryApis = cloneDeep(this.mandatoryApis);
                        res.data.loadDU = false;
                        res.data.selectedTarget = false;
                        res.data.zIndex = 0;
                        this.parentIndicator.mainTargets.push(res.data);
                        this.$bvModal.hide("create-target-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }

            this.submitted = false;
        },
        async updateIndicatorItem(row, parent){
            this.parentIndicator = parent;
            this.target = cloneDeep(row);
            this.target.overAllTarget = row.overAllTarget.toString();
            this.modalTitle = "Update Main Target";
            this.$bvModal.show("create-target-modal");
        },
        deleteIndicatorItem(rows, parent){
            let array = [];
            rows.map(item => {
                array.push(item.id);
            })
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, remove it!",
            }).then(async (result) => {
                if (result.value) {
                    let error = 0;
                    for await(const x of array){
                        await this.$store
                            .dispatch(
                                "planningtemplatemaintarget/DeletePTMT",
                                x
                            )
                            .then((res) => {
                                if(res.data.error){
                                    error++;
                                }
                                let index = parent.mainTargets.findIndex((y) => y.id == x);
                                parent.mainTargets.splice(index, 1);
                            })
                            .catch((err) => {
                                error++;
                            });
                    }
                    if(error > 0){
                        this.showToast('Something went wrong', 'error')
                    }else{
                        parent.selectedTargets = []
                        this.showToast('Successfully removed', 'success')
                    }
                }
            });
        },
        viewAPIs(row){
            this.selectedDU = row;
            this.modalTitle = 'View APIs';
            this.$bvModal.show("api-modal");
            this.addApi = false;
            this.viewingApi = false;
            this.getAPI(row, 'template');
        },
        async getAPI(row, type){
            this.apiLoading = true;
            this.apiData = [];
            if(type === 'template'){
                await this.$store
                    .dispatch(
                        "planningtemplateapi/GetPlanningTemplateApi",
                        row.id
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        res.data.map((item) => {
                            item.editMode = false;
                        });
                        this.apiData = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }else{
                await this.$store
                    .dispatch(
                        "api/GetApiByTarget",
                        row.id
                    )
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        if(!res.data.map){
                            return;
                        }
                        res.data.map((item) => {
                            item.editMode = false;
                        });
                        this.apiData = res.data;
                    })
                    .catch((err) => {
                        this.showToast("Something went wrong!", "error");
                    });
            }
            this.apiLoading = false;
        },
        resetApi(){
            this.api = {
                id: 0,
                planningTemplateDeliveryUnitId: 0,
                name: '',
                description: '',
                apiTypeId: '',
                priority: false,
                apiType: {
                    type: '',
                },
            };
            this.$v.api.$reset();
        },
        addMoreApi(){
            this.addApi = !this.addApi;
            if(this.addApi){
                this.resetApi();
            }
        },
        showApiType(){
            this.$bvModal.show("api-type-modal");
        },
        dropType(row){
            this.api.apiType = row;
            this.api.apiTypeId = row.id;
        },
        async saveApi(){
            this.submitted = true;
            this.$v.api.$touch();
            if (this.$v.api.$invalid) {
                return;
            }
            let data = cloneDeep(this.api);
            data.planningTemplateDeliveryUnitId = this.selectedDU.id;
            if(this.api.id == 0){
                await this.$store
                .dispatch(
                    "planningtemplateapi/CreatePlanningTemplateApi",
                    data
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    res.data.apiType = this.api.apiType;
                    res.data.editMode = false;
                    this.apiData.push(res.data);
                    this.addApi = false;
                    this.showToast("Successfully added!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            }else{
                await this.$store
                .dispatch(
                    "planningtemplateapi/UpdatePlanningTemplateApi",
                    data
                )
                .then((res) => {
                    if (res.data.error) {
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.apiData.findIndex((item) => item.id == this.api.id);
                    this.api.editMode = false;
                    this.apiData.splice(index, 1, this.api);
                    this.showToast("Successfully updated!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error");
                });
            }
        },
        updateApi(row){
            row.editMode = true;
            this.api = cloneDeep(row);
            this.api.apiType = cloneDeep(row.apiType);
        },
        deleteApi(row){
            let index = this.apiData.indexOf(row);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then(async (result) => {
                if (result.value) {
                    await this.$store
                        .dispatch(
                            `planningtemplateapi/DeletePlanningTemplateApi`,
                            row.id
                        )
                        .then((res) => {
                            if (res.data.error) {
                                return this.showToast(
                                    res.data.errorMessage,
                                    "error"
                                );
                            }
                            this.apiData.splice(index, 1);
                            this.showToast("Successfully deleted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Something went wrong!", "error");
                        });
                }
            });
        },
        viewRubric(row){
            this.selectedPlanningMainTarget = row;
            this.$refs.PlanningRatingScale.setMeasurement(row, 'du');
            this.$bvModal.show("performance-rating-modal");
        },
        postIndicatorItem(row, parent){
            let duIds = [];
            row.dus.map(item => {
                if(!item.status){
                    duIds.push({id: item.deliveryUnitId});
                }
            })
            // let index = parent.mainTargets.findIndex((x) => x.id == row.id);
            Swal.fire({
                title: "Are you sure?",
                text: "You want to post this?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, post it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "planningtemplatedu/PostDUTemplate",
                            {
                                cycle: this.$store.state.data.cycle,
                                planningMainTargetId: row.mainTargetId,
                                campusId: row.campusId,
                                duIds: duIds,
                            }
                        )
                        .then((res) => {
                            if(res.data.error){
                                return this.showToast(res.data.errorMessage, 'error');
                            }
                            row.dus.map(item => {
                                if(!item.status){
                                    item.status = 'Posted';
                                }
                            })
                            // parent.mainTargets[index].status = "Posted";
                            this.showToast("Successfully posted!", "success");
                        })
                        .catch((err) => {
                            this.showToast("Cannot be posted!", "error");
                        });
                    }
                });
        },
        selectTarget(item, parent){
            if(item.type){
                parent.selectedTargets.push({id: item.id});
            }else{
                let index = parent.selectedTargets.findIndex(x => x.id == item.id);
                parent.selectedTargets.splice(index, 1)
            }
        },
    },
    
}
</script>
<template>
    <!-- @changeCampus="getCampusTemplate($event.id)" -->
    <Layout >
        <PageHeader :title="title" :items="items" />
        <b-modal
            id="create-target-modal"
            :title="modalTitle"
            size="md"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <form
                @submit.prevent="onCreateTarget"
                autocomplete="off"
                class="needs-validation"
                ref="targetForm"
            >
                
                <div class="mb-3">
                    <label for="target-description"
                        >Target Description</label
                    >
                    <textarea
                        id="target-description"
                        class="form-control"
                        rows="5"
                        v-model="target.description"
                        placeholder="Enter Target Description"
                        :class="{
                            'border-danger':
                                !target.description &&
                                submitted,
                        }"
                    ></textarea>
                </div>
                <div>
                    <label for="overall-target"
                        >Overall Target</label
                    >
                    <masked-input
                        id="overall-target"
                        type="text"
                        class="form-control w-100"
                        placeholder="Overall Target"
                        v-model="target.overAllTarget"
                        :mask="currencyMask"
                        :class="{
                            'border-danger':
                                !target.overAllTarget &&
                                submitted,
                        }"
                    ></masked-input>
                </div>
                <div class="mt-3 d-flex align-items-center">
                    <div class="d-flex align-items-center">
                        <switches
                            v-model="target.isPercentage"
                            id="isPercentage"
                        ></switches>
                        <label for="isPercentage" class="mx-2">
                            <span v-if="target.isPercentage"
                                >Percentage</span
                            >
                            <del v-else>Percentage</del>
                        </label>
                    </div>
                    <div class="d-flex align-items-center">
                        <switches
                            v-model="target.allowAdd"
                            id="allowAdd"
                        ></switches>
                        <label for="allowAdd" class="mx-2">
                            <span v-if="target.allowAdd"
                                >Allow DU to Add</span
                            >
                            <del v-else>Allow DU to Add</del>
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary">
                        Save changes
                    </button>
                    <button
                        type="button"
                        class="btn btn-link"
                        @click="$bvModal.hide('create-target-modal')"
                    >
                        Close
                    </button>
                </div>
            </form>
        </b-modal>
        <b-modal
            id="api-modal"
            :title="modalTitle"
            size="xl"
            title-class="font-18"
            hide-footer
            no-close-on-backdrop
        >
            <ul>
                <li>
                    <b class="font-size-14">Main Target:</b> <span class="font-size-16"><u>{{ selectedDU && selectedDU.description }}</u></span>
                </li>
                <li>
                    <b class="font-size-14">Delivery Unit:</b> <span class="text-warning font-size-16">{{ selectedDU && selectedDU.deliveryUnit.name }}</span>
                </li>
            </ul>
            <table class="table table-bordered ">
                <thead>
                    <tr>
                        <th width="40%">
                            <div class="d-flex">
                                API Name/Description
                                <button 
                                type="button"
                                class="
                                    btn
                                    btn-warning
                                    btn-sm
                                    px-2
                                    py-0
                                    ms-1
                                "
                                v-if="!viewingApi"
                                @click="addMoreApi"
                                >
                                    <template v-if="!addApi">
                                        <i class="bx bx-plus"></i>Add More
                                    </template>
                                    <template v-else>
                                        <i class="bx bx-x"></i>Cancel
                                    </template>
                                </button>
                            </div>
                        </th>
                        <th :width="viewingApi && '20%'">API Type</th>
                        <th v-if="!viewingApi" class="text-center" :width="!addApi ? '90px' : '10%' ">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="!apiLoading && apiData.length == 0 && !addApi">
                        <td :colspan="!viewingApi ? 3 : 2" class="text-center">No Data Found</td>
                    </tr>
                    <template v-if="!apiLoading && apiData.length > 0">
                        <template v-for="x in apiData">
                            <tr :key="`parent-not-edit-${x.id}`" v-if="!x.editMode">
                                <td>
                                    <div>{{ x.name }}</div>
                                    <small>{{x.description}}</small>
                                </td>
                                <td>
                                    {{x.apiType.type}}
                                </td>
                                <td class="align-middle" v-if="!viewingApi">
                                    <div class="
                                            d-flex
                                            justify-content-center
                                            align-items-center
                                        ">
                                        <button type="button" title="Edit" class="btn btn-link p-0 font-size-16 me-1" @click="updateApi(x)">
                                            <i class="bx bx-edit"></i>
                                        </button>
                                        <button type="button" title="Delete" class="btn btn-link p-0 font-size-16"  @click="deleteApi(x)">
                                            <i class=" bx bx-trash text-danger"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                            <tr :key="`parent-edit-${x.id}`" v-else>
                                <td>
                                    <input
                                        type="text"
                                        class="form-control mb-3"
                                        v-model="api.name"
                                        placeholder="Enter API Name"
                                        :class="{
                                            'is-invalid':
                                                submitted && $v.api.name.$error,
                                        }"
                                    />
                                    <textarea
                                        rows="3"
                                        class="form-control"
                                        v-model="api.description"
                                        placeholder="Enter API Description"
                                        :class="{
                                            'is-invalid':
                                                submitted && $v.api.description.$error,
                                        }"
                                    />
                                </td>
                                <td>
                                    <input
                                        type="text"
                                        class="form-control cursor-pointer"
                                        v-model="api.apiType.type"
                                        placeholder="Click to Select Api Type"
                                        readonly
                                        @click="showApiType"
                                        :class="{
                                            'is-invalid':
                                                submitted && $v.api.apiTypeId.$error,
                                        }"
                                    />
                                </td>
                                <td class="text-center" v-if="!viewingApi">
                                    <button
                                        type="button"
                                        class="btn btn-success"
                                        @click="saveApi"
                                    >
                                        <i class="bx bx-save"></i> Save
                                    </button>
                                    <button
                                        type="button"
                                        class="btn btn-clear"
                                        @click="x.editMode = false"
                                    >
                                        <i class="bx bx-x"></i> Cancel
                                    </button>
                                </td>
                            </tr>
                        </template>
                    </template>
                    <template v-if="addApi">
                        <tr>
                            <td>
                                <input
                                    type="text"
                                    class="form-control mb-3"
                                    v-model="api.name"
                                    placeholder="Enter API Name"
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.api.name.$error,
                                    }"
                                />
                                <textarea
                                    rows="3"
                                    class="form-control"
                                    v-model="api.description"
                                    placeholder="Enter API Description"
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.api.description.$error,
                                    }"
                                />
                            </td>
                            <td>
                                <input
                                    type="text"
                                    class="form-control cursor-pointer"
                                    v-model="api.apiType.type"
                                    placeholder="Click to Select Api Type"
                                    readonly
                                    @click="showApiType"
                                    :class="{
                                        'is-invalid':
                                            submitted && $v.api.apiTypeId.$error,
                                    }"
                                />
                            </td>
                            <td class="text-center">
                                <button
                                    type="button"
                                    class="btn btn-success"
                                    @click="saveApi"
                                >
                                    <i class="bx bx-save"></i> Save
                                </button>
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </b-modal>
        <div class="card position-relative border shadow mt-2">
            <div class="card-header px-3 pt-3">
                <div class="d-flex align-items-center justify-content-between">
                    <!-- <h4
                        class="card-title mb-0"
                        :id="'template-' + $store.state.data.selectedCampus.id + '-' + $store.state.data.cycle"
                    >
                        {{ $store.state.data.selectedCampus.campusName }} ({{ $store.state.data.cycle }}) Template
                    </h4> -->
                    
                    <div class="d-flex align-items-center">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-end"
                        >
                            <label
                                class="d-inline-flex align-items-center mb-0"
                            >
                                <b-form-input
                                    autocomplete="off"
                                    v-model="filter"
                                    type="search"
                                    placeholder="Search KRA/DYNAMIC/PREXC..."
                                    class="form-control"
                                    width="350px"
                                ></b-form-input>
                                <b-dropdown
                                    menu-class="dropdown-menu-end"
                                    variant="black"
                                    toggle-class="p-0"
                                >
                                    <template v-slot:button-content>
                                        <a
                                            href="javascript:void(0);"
                                            class="
                                                font-size-20
                                                mx-2
                                                text-dark
                                            "
                                            ><i class="bx bx-slider"></i
                                        ></a>
                                    </template>
                                    <b-dropdown-item
                                        @click="filterBy = 'all'"
                                    >
                                        <div class="d-flex">
                                            <div style="width: 20px">
                                                <i
                                                    class="bx bx-check"
                                                    v-if="
                                                        filterBy ===
                                                        'all'
                                                    "
                                                ></i>
                                            </div>
                                            All
                                        </div>
                                    </b-dropdown-item>
                                    <b-dropdown-item
                                        v-for="x in itemClassifications"
                                        :key="x.id"
                                        @click="
                                            filterBy = x.classification
                                        "
                                    >
                                        <div class="d-flex">
                                            <div style="width: 20px">
                                                <i
                                                    class="bx bx-check"
                                                    v-if="
                                                        filterBy ===
                                                        x.classification
                                                    "
                                                ></i>
                                            </div>
                                            {{ x.classification }}
                                        </div>
                                    </b-dropdown-item>
                                </b-dropdown>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <template v-for="w in filtered">
                    <div :key="w.id">
                        <div class="d-flex align-items-center">
                            <div style="width:10px;height:10px;border-radius:50%;" class="bg-success me-1"></div>
                            <h4 class="my-2">{{w.prexcClass.classification}}</h4>
                        </div>
                        <div class="ms-4">
                            <template v-for="z in filteredPrexc(w.items)">
                                <b-card
                                    :key="z.id"
                                    no-body
                                    class="mb-1 shadow-none"
                                >
                                    <b-card-header
                                        header-tag="header"
                                        role="tab"
                                        class="border"
                                    >
                                        <div
                                            class="
                                                d-flex
                                                justify-content-between
                                                align-items-center
                                            "
                                        >
                                            <div class="d-flex align-items-start">
                                                <div style="width: 5px;height:5px;" class="bg-warning bg-gradient text-center me-2 mt-1"></div>
                                                <div class="text-muted">
                                                    <h5 class="mb-0 line-height-1 hover-underline cursor-pointer" @click="z.rotateChevy = !z.rotateChevy">
                                                        {{ z.prexc.prexcName }}
                                                    </h5>
                                                </div>
                                            </div>
                                            <div>
                                                <a href="javascript:void(0)" @click="z.rotateChevy = !z.rotateChevy">
                                                    <i class="bx  font-size-24" :class="[z.rotateChevy ? 'bx-chevron-down' : 'bx-chevron-right']"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </b-card-header>
                                    <b-collapse
                                        :visible="z.rotateChevy"
                                        :accordion="`prexc-${z.id}`"
                                        role="tabpanel"
                                    >
                                        <b-card-body class="border">
                                            <b-tabs
                                                pills
                                                vertical
                                                nav-class="p-0"
                                                nav-wrapper-class="col-sm-2"
                                                content-class="pt-0 px-2 text-muted border-start"
                                            >
                                                <b-tab title-item-class="mb-2" v-for="x in filteredGroupIndicators(z.items)" :key="x.id">
                                                    <template v-slot:title>{{x.indicatorName}}</template>
                                                    <div class="mb-2 d-flex justify-content-between align-items-center">
                                                        <h5 class="mb-0">KPI List</h5>
                                                        <input type="text" class="form-control form-control-sm me-1" placeholder="Search KPI..." v-model="x.searchFilter" style="width:250px;">
                                                    </div>
                                                    <div class="card mb-2" v-for="(y, yIndex) in filteredIndicatorItems(x.indicatorItems, x.searchFilter)" :key="`A${x.id}-B${y.id}`" :style="`z-index: ${x.indicatorItems.length - yIndex}`">
                                                        <div class="card-header">
                                                            <div
                                                                class="
                                                                    text-muted
                                                                "
                                                            >
                                                                <div
                                                                    class="
                                                                        d-flex
                                                                    "
                                                                >
                                                                    <h5
                                                                        class="
                                                                            mb-0
                                                                        "
                                                                    >
                                                                        {{
                                                                            y.indicatorItemName
                                                                        }}
                                                                    </h5>
                                                                    <span
                                                                        class="
                                                                            badge
                                                                            bg-purple
                                                                            ms-2
                                                                        "
                                                                        style="
                                                                            line-height: unset !important;
                                                                        "
                                                                        >{{
                                                                            y
                                                                                .indicatorItemClassification
                                                                                .classification
                                                                        }}</span
                                                                    >
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <small
                                                                    class="
                                                                        d-flex
                                                                        align-items-center
                                                                    "
                                                                    >{{
                                                                        y.type
                                                                    }}
                                                                    |
                                                                    <a
                                                                        href="javascript: void(0);"
                                                                        class="
                                                                            text-success
                                                                            d-flex
                                                                            align-items-center
                                                                            ms-1
                                                                        "
                                                                        @click="viewMainTargets(y)"
                                                                    >
                                                                        {{
                                                                            y.visible
                                                                                ? "Hide"
                                                                                : "Show"
                                                                        }}
                                                                        Main Targets
                                                                        <i
                                                                            class="
                                                                                bx
                                                                                bx-chevron-right
                                                                                rotate
                                                                                font-size-14
                                                                            "
                                                                            :class="{
                                                                                'rotate-90':
                                                                                    y.visible,
                                                                            }"
                                                                        ></i>
                                                                    </a>
                                                                </small>
                                                            </div>
                                                        </div>
                                                        <b-collapse
                                                            :visible="y.visible"
                                                            :accordion="`detail-accordion-${y.id}`"
                                                            role="tabpanel"
                                                        >
                                                            <b-card-body
                                                                class="border my-2"
                                                            >
                                                                <div class="d-flex align-items-end justify-content-between">
                                                                    <div>
                                                                        <h4 class="m-0">Target List</h4>
                                                                        <small v-if="$store.state.decrypt.isAdmin()"><a href="javascript:void(0);" class="text-secondary" @click="y.singleSelection = !y.singleSelection">{{y.singleSelection ? `Single` : `Multiple`}} Selection</a></small>
                                                                    </div>
                                                                    <div class="d-flex">
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-danger me-1"
                                                                            @click="deleteIndicatorItem(y.selectedTargets, y)"
                                                                            v-if="y.selectedTargets.length"
                                                                        >
                                                                            <i class="bx bx-minus"></i>Remove Selected
                                                                        </button>
                                                                        <button
                                                                            type="button"
                                                                            class="btn btn-primary"
                                                                            @click="createNewTarget(y)"
                                                                        >
                                                                            <i class="bx bx-plus"></i>Create New Target
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    v-if="y.mainTargetLoading" 
                                                                    class="
                                                                        d-flex
                                                                        justify-content-center
                                                                        align-items-center
                                                                        my-5
                                                                    "
                                                                >
                                                                    <div class="preloader-component me-2">
                                                                        <div class="status">
                                                                            <div
                                                                                class="
                                                                                    spinner-chase
                                                                                    w-20px
                                                                                    h-20px
                                                                                "
                                                                            >
                                                                                <div
                                                                                    class="chase-dot"
                                                                                ></div>
                                                                                <div
                                                                                    class="chase-dot"
                                                                                ></div>
                                                                                <div
                                                                                    class="chase-dot"
                                                                                ></div>
                                                                                <div
                                                                                    class="chase-dot"
                                                                                ></div>
                                                                                <div
                                                                                    class="chase-dot"
                                                                                ></div>
                                                                                <div
                                                                                    class="chase-dot"
                                                                                ></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <strong>Loading...</strong>
                                                                </div>
                                                                <div v-else>
                                                                    <main-target-template 
                                                                        :fromTemplate="true"
                                                                        :mainTargets="y.mainTargets" 
                                                                        :singleSelection="y.singleSelection"
                                                                        :mandatory="y.indicatorItemClassification.classification.toLowerCase().includes('mandatory') ? true : false"
                                                                        @delete="deleteIndicatorItem([$event], y)" 
                                                                        @post="postIndicatorItem($event, y)"
                                                                        @update="updateIndicatorItem($event, y)"
                                                                        @open-imports="openImports($event, y)"
                                                                        :ref="`mainTargetTemplate${y.id}`"
                                                                        @view-apis="viewAPIs"
                                                                        @view-rubric="viewRubric"
                                                                        @selectTarget="selectTarget($event, y)"
                                                                    ></main-target-template>
                                                                </div>
                                                            </b-card-body>
                                                        </b-collapse>
                                                    </div>
                                                </b-tab>
                                            </b-tabs>
                                        </b-card-body>
                                    </b-collapse>
                                </b-card>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <api-type @dropData="dropType($event)"></api-type>
        <PlanningRatingScale :fromTemplate="true" ref="PlanningRatingScale"/>
    </Layout>
</template>